import idSerializer from "geotab-uuid";
import { NODEVICEID } from "./DutyStatusLog";
import TripAnnotation from "./TripAnnotation";

export interface ITrip extends IIdEntity {
    start?: string;
    stop?: string;
    nextTripStart?: string;
    distance?: number;
    driver: IIdEntity | "UnknownDriverId";
    device: IIdEntity;
    stopPoint: ICoordinate;

    /* eslint-disable @typescript-eslint/naming-convention */
    _startPoint?: ICoordinate;
    _tripType?: string;
    _groupLinkedDeviceId?: string;
    _annotation?: TripAnnotation;
    _midPoint?: string;
    /* eslint-enable @typescript-eslint/naming-convention */
}

export default class Trip implements ITrip {
    distance?: number;
    id: string;
    start?: string;
    stop?: string;
    nextTripStart?: string;
    driver: IIdEntity | "UnknownDriverId";
    device: IIdEntity;
    stopPoint: ICoordinate;

    /* eslint-disable @typescript-eslint/naming-convention */
    _startPoint?: ICoordinate;
    _tripType?: string;
    _groupLinkedDeviceId?: string;
    _annotation?: TripAnnotation;
    _midPoint?: string;

    constructor(obj: DeepReadonly<ITrip>) {
        this.id = obj.id || idSerializer.get();
        this.driver = obj.driver && obj.driver !== "UnknownDriverId" ? { id: obj.driver.id } : "UnknownDriverId";
        this.device = obj.device && obj.device.id ? obj.device : { id: NODEVICEID };
        this.start = obj.start;
        this.stop = obj.stop;
        this.nextTripStart = obj.nextTripStart;
        this.distance = obj.distance;
        this.stopPoint = obj.stopPoint;
        this._startPoint = obj._startPoint;
        this._tripType = obj._tripType;
        this._groupLinkedDeviceId = obj._groupLinkedDeviceId;
        this._annotation = obj._annotation;
        this._midPoint = obj._midPoint;
    }
    /* eslint-enable @typescript-eslint/naming-convention */
}